export default "__VITE_ASSET__BX88ETHK__"